import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { DAYS_MPLUS } from 'shared/constants'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  currentDate?: number
  currentPrice?: string
  onChange?: (value: number) => void
  onShowDetailPaymentDays?: () => void
}

export const SelectPaymentDate: FC<Props> = ({
  currentDate,
  onChange,
  onShowDetailPaymentDays,
}) => {
  const { t } = useTranslation()

  return (
    <div className={s.selectPaymentDate}>
      <div className={s.header}>
        <h4 className={clsx(s.title, 'semi-bold-16')}>
          {t('mplus.select_payment_date')}
        </h4>
        <AppIcon
          id={AllIcons.INFO}
          className={s.icon}
          onClick={onShowDetailPaymentDays}
        />
      </div>

      <div className={s.swiper}>
        {DAYS_MPLUS?.map((day) => {
          return (
            <div
              key={day}
              className={clsx(s.swiperCard, currentDate === day && s.active)}
              onClick={() => onChange?.(day)}
            >
              <span className={clsx(s.date, 'semi-bold-14')}>
                {day} {t('mplus.number')}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
